import { jsx as _jsx } from "react/jsx-runtime";
import { memo, forwardRef, useCallback } from 'react';
import { Dialog, Slide, useMediaQuery, useTheme, } from '@mui/material';
import { ModalCloseTypes } from '../../enums/ModalCloseTypes';
import modalStyles from './modal.styles';
import ModalPaper from './ModalPaper';
// TODO fix react hook linting error exhaustive-deps
/* eslint-disable react-hooks/exhaustive-deps */
const Transition = forwardRef(function Transition(props, ref) {
    return (_jsx(Slide, { direction: "down", ref: ref, ...props, timeout: 500 }, void 0));
});
const Modal = memo(({ children, labelledBy, hideCloseIcon, onClose, toggleModal, PaperProps, ...rest }) => {
    const styles = modalStyles();
    const isBelowTablet = useMediaQuery(useTheme().breakpoints.down('sm'));
    const handleClose = useCallback((_event, reason) => {
        if (reason !== ModalCloseTypes.BACKDROP_CLICK && onClose) {
            onClose();
        }
    }, []);
    return (_jsx(Dialog, { "aria-labelledby": labelledBy, classes: { paper: styles.container }, onClose: handleClose, PaperComponent: ModalPaper, PaperProps: {
            ...PaperProps,
            hideCloseIcon,
            onClose,
            toggleModal,
        }, ...rest, ...(isBelowTablet ? { fullScreen: true } : {}), TransitionComponent: Transition, disableEscapeKeyDown: true, children: children }, void 0));
});
export default Modal;
//# sourceMappingURL=Modal.js.map